import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';

@Injectable()
export class PositionsServiceMock {
  download = () => EMPTY;
  downloadCsvRequestedSubject = EMPTY;
}
